import React from 'react';
import PropTypes from 'prop-types';

import { LayoutMain } from '@xingternal/platform-layout-main';

const XingView = (props) => {
  return <LayoutMain {...props} />;
};

XingView.propTypes = {
  children: PropTypes.node,
};

export default XingView;
